import React from "react";
import { Dialog, DialogActions } from "@mui/material";
const CustomModal = ({
  open,
  onClose,
  children,

}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
      
        "& .MuiDialog-paper": {
          borderRadius: "32px",
          background: "#FFF",
          width: "100%",
          maxWidth: "480px",
          // maxWidth:'auto',
          boxSizing: "border-box",
          marginRight: {
            xs: "30px",
            sm: "30px",
            md: "30px",
            lg: "35px",
            // xl: "38px",
          },
          "@media (min-width: 1600px)": {
            marginRight: "32px",
          },
          display: "flex",
          flexDirection: "column",
        },
       
      }}
    >
      {children}

    </Dialog>
  );
};

export default CustomModal;